import { useQuery } from "@tanstack/react-query";
import { getTaskLogsQueryKey } from "./queryKeyHelper";
import { getTaskLogs } from "./tasks.service";
import { createPreviousOnNullPlaceholderDataFn } from "@coworker/apprestructured/src/task-management/services/queryHelper";
import { Log } from "@coworker/apprestructured/src/task-management/types/Log";

export const useTaskLogs = (id: string | null) => {
  return useQuery({
    queryKey: getTaskLogsQueryKey(id),
    queryFn: () => getTaskLogs(id!),
    enabled: id !== null,
    placeholderData: createPreviousOnNullPlaceholderDataFn<Log[]>(id),
  });
};
